import React, { useState } from 'react';
import { PersonSvg } from '../../assets/svg';
import TopHeaderSection from '../common/TopHeaderSection';
import AstrologerLoginModal from '../modal/AstrologerLoginModal';
import { generateTokenByRequestPermission } from '../../config/firebase-config';

const PleaseLoginAstrologer = () => {
    // Todo : Astrolger Login Start
    const [loginAstrologerModal, setLoginAstrologerModal] = useState(false);

    const handleOpenLoginAstrologerModal = async () => {
        console.log('Astrologer login button clicked');

        if (!("Notification" in window)) {
            alert("This browser does not support desktop notifications.");
        } else if (Notification.permission === "granted") {
            generateTokenByRequestPermission();
            setLoginAstrologerModal(true)

        } else if (Notification.permission === "denied") {
            alert("You have blocked notifications. Please enable them in your browser settings.");

        } else if (Notification.permission === "default") {
            console.log('Requesting Notification Permission');
            const permission = await Notification.requestPermission();
        }
    };

    const handleCloseLoginAstrologerModal = () => setLoginAstrologerModal(false);

    return (
        <>
            <TopHeaderSection />

            <div className="flex items-center justify-center min-h-[400px] bg-greyBg">
                <div className="bg-white flex flex-col items-center gap-2 p-6 rounded-lg shadow-md shadow-primary">
                    <h1 className="text-secondary text-xl font-semibold">Please Login First</h1>
                    <p className="text-grey text-sm mb-2">You need to be logged as a astrologer to access this content.</p>
                    <button onClick={handleOpenLoginAstrologerModal} className='flex items-center gap-2 cursor-pointer bg-primary text-white px-4 py-1.5 rounded-full text-[15px]'><div className='-mt-0.5'><PersonSvg /></div><div>Login</div></button>
                </div>
            </div>

            {/* Astrologer Modal */}
            <AstrologerLoginModal isOpen={loginAstrologerModal} handleCloseModal={handleCloseLoginAstrologerModal} />
        </>
    );
}

export default PleaseLoginAstrologer;